/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef } from 'react'
import Filter from '../Filter'
import IconClose from '../../assets/icons/icon-close.svg'
import * as S from './styles'

const FilterMobile = ({
  showMenu,
  setShowMenu,
  click,
  opcoes,
  pedido,
  gimplus,
  small,
  promotor
}) => {
  const modalRef = useRef()

  const closeMenu = (e) => {
    if (modalRef.current === e.target) {
      setShowMenu(false)
    }
  }

  return (
    <>
      {showMenu ? (
        <S.Modal onClick={closeMenu}>
          <S.FilterMobileContent>
            <S.CloseModal onClick={() => setShowMenu((prev) => !prev)}>
              <img src={IconClose} alt="" />
            </S.CloseModal>
            <S.FilterMobileBox>
              <S.FilterMobileHeader>Filtros</S.FilterMobileHeader>
              <S.Wrapper>
                <Filter
                  className="mobile"
                  click={click}
                  opcoes={opcoes}
                  pedido={pedido}
                  promotor={promotor}
                  gimplus={gimplus}
                  small={small}
                  setShowMenu={setShowMenu}
                  calendarModal
                ></Filter>
              </S.Wrapper>
            </S.FilterMobileBox>
          </S.FilterMobileContent>
        </S.Modal>
      ) : null}
    </>
  )
}

export default FilterMobile
